import { render, staticRenderFns } from "./PrefSwitch.vue?vue&type=template&id=3198197b&scoped=true"
import script from "./PrefSwitch.vue?vue&type=script&lang=js"
export * from "./PrefSwitch.vue?vue&type=script&lang=js"
import style0 from "./PrefSwitch.vue?vue&type=style&index=0&id=3198197b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3198197b",
  null
  
)

export default component.exports